import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import CustomCursor from "./components/CustomCursor";

import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import PricingPage from "./pages/PricingPage";
import DemosPage from "./pages/DemosPage";
import DemoRouter from "./pages/DemoRouter";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RestaurantDemo from "./pages/RestaurantDemo";
import ClinicDemo from "./pages/ClinicDemo";
import CafeDemo from "./pages/CafeDemo";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function AppRoutes() {
  const location = useLocation();
  const isDemoPath = location.pathname.startsWith("/demo/");

  const isDemo =
    isDemoPath ||
    location.pathname.startsWith("/restaurant-demo") ||
    location.pathname.startsWith("/clinic-demo") ||
    location.pathname.startsWith("/cafe-demo");

  return (
    <>
      {!isDemo && <Navbar />}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/demos" element={<DemosPage />} />
          <Route path="/demo/:slug" element={<DemoRouter />} />
          <Route path="/restaurant-demo" element={<RestaurantDemo />} />
          <Route path="/clinic-demo" element={<ClinicDemo />} />
          <Route path="/cafe-demo" element={<CafeDemo />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AnimatePresence>
      {!isDemo && <Footer />}
      {!isDemo && <WhatsAppFloat />}
    </>
  );
}

function App() {
  return (
    <div className="App relative">
      <LanguageProvider>
        <CustomCursor />
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
